/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IUserState {
  profile: any;
  isTriggerGetUser: boolean;
  isRejectedDocument: boolean;
}

const initialState: IUserState = {
  profile: null,
  isTriggerGetUser: false,
  isRejectedDocument: false
};

export const profileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    setProfile: (state: IUserState, action: PayloadAction<{}>) => {
      const { payload } = action;
      state.profile = payload;
    },
    setIsTriggerGetUser: (state: IUserState, action: PayloadAction<boolean>) => {
      const { payload } = action;
      state.isTriggerGetUser = payload;
    },
    setIsRejectedDocument: (state: IUserState, action: PayloadAction<boolean>) => {
      const { payload } = action;
      state.isRejectedDocument = payload;
    }
  }
});

const { actions, reducer } = profileSlice;
export const { setProfile, setIsTriggerGetUser, setIsRejectedDocument } = actions;
export default reducer;
